export default {
  registration: {
    give_mandate: {
      badge_tooltip: "Verwaltungsmandat erteilt",
    },
    invoice: {
      filter: {
        active: "Aktive Filter",
        remove: "Filter {name} entfernen",
        status: "Nach Status filtern",
      },
      title: ({ plural }) => plural(["Rechnung", "Rechnungen"]),
      global_totals: ({ plural, named }) =>
        plural([
          `Insgesamt ${named("count")} Fälligkeit in diesem Strom (fakturiert oder nicht)`,
          `Insgesamt ${named("count")} Fälligkeiten in diesem Strom (fakturiert oder nicht)`,
        ]),
      flow: {
        all: "Alle Ströme",
        opco: "OPCO",
        company: "Unternehmen",
      },
      emitted: {
        title: ({ plural }) => plural(["Ausgestellte Rechnung", "Ausgestellte Rechnungen"]),
        resend: "Rechnung erneut senden",
        resend_reference: "Rechnung {reference} erneut senden",
        resend_confirmation: "Sind Sie sicher, dass Sie diese Rechnung erneut senden möchten?",
        see_error: "Fehler anzeigen",
        error_date: "Datum des Fehlers: {date}",
        resend_rejection: {
          title: "Die Rechnung konnte nicht erneut gesendet werden",
          reference: "Rechnung",
          dismiss: "Meldung zum Fehler beim erneuten Senden schließen",
        },
        see_details: "Details anzeigen",
        download_pdf: "Rechnung herunterladen",
        download_completion_certificate: "Durchführungsbescheinigung herunterladen",
      },
      retry: {
        tooltip: "PDF-Erzeugung erneut starten",
        success: "Die PDF-Erzeugung wurde erfolgreich erneut gestartet.",
      },
      credit_note: {
        document_title: "Gutschrift",
        download_pdf: "Gutschrift herunterladen",
        emit: "Gutschrift ausstellen",
        title: "Ausstellung einer Gutschrift",
        confirm: "Möchten Sie diese Gutschrift wirklich ausstellen?",
        success: "Gutschrift erfolgreich ausgestellt!",
        type_total: "Vollständige Gutschrift",
        type_partial: "Teilgutschrift",
        confirm_irreversible: "Diese Aktion ist endgültig und kann nicht rückgängig gemacht werden.",
        pdf_failed: "Die Gutschrift wurde erstellt, aber ihr PDF konnte nicht erzeugt werden.",
        pdf_failed_retry: "Möchten Sie die PDF-Erzeugung jetzt erneut starten?",
        see_origin_invoice: "Ursprüngliche Rechnung anzeigen",
        see_origin_invoice_label: "Ursprüngliche Rechnung Nr. {code} anzeigen",
      },
      attached_credit_notes: {
        title: ({ plural, named }) =>
          plural([
            `Zu dieser Rechnung wurde ${named("count")} Gutschrift ausgestellt`,
            `Zu dieser Rechnung wurden ${named("count")} Gutschriften ausgestellt`,
          ]),
        number: "Gutschrift Nr. {number}",
        issued_at: "Ausgestellt am {date}",
        reason: "Grund: {reason}",
        see_credit_note: "Gutschrift anzeigen",
        see_credit_note_label: "Gutschrift Nr. {number} anzeigen",
      },
      schedule: {
        title: ({ plural }) => plural(["Zu fakturierende Fälligkeit", "Zu fakturierende Fälligkeiten"]),
        selected: ({ plural, named }) =>
          plural([`${named("count")} Fälligkeit ausgewählt`, `${named("count")} Fälligkeiten ausgewählt`]),
        total_amount: "Gesamtbetrag: {amount}",
        cancel_selection: "Auswahl aufheben",
        emit: "Rechnungen ausstellen",
        emit_confirmation: ({ plural, named }) =>
          plural([
            `Rechnung für die ausgewählte Fälligkeit ausstellen?`,
            `Rechnungen für die ${named("count")} ausgewählten Fälligkeiten ausstellen?`,
          ]),
        emit_progress: {
          title: "Rechnungen werden ausgestellt",
          label: "Ausgestellte Rechnungen: {done} / {total}",
        },
        rejection: {
          title: ({ plural, named }) =>
            plural([
              `${named("count")} Fälligkeit konnte nicht zur Rechnungsstellung vorgemerkt werden`,
              `${named("count")} Fälligkeiten konnten nicht zur Rechnungsstellung vorgemerkt werden`,
            ]),
          reference: "Fälligkeit",
          reason: "Grund",
          dismiss: "Meldung zu den abgelehnten Fälligkeiten schließen",
        },
      },
      emit: {
        title: "Rechnungen ausstellen",
        summary: {
          line: "Ihre Auswahl umfasst {schedules} für {recipients}, mit einem Gesamtbetrag von {amount}.",
          schedules: ({ plural, named }) => plural([`${named("count")} Fälligkeit`, `${named("count")} Fälligkeiten`]),
          recipients: ({ plural, named }) => plural([`${named("count")} Empfänger`, `${named("count")} Empfänger`]),
        },
        cancel: "Abbrechen",
        confirm: "Rechnungen ausstellen",
        alerts: {
          title: ({ plural }) => plural(["Zu prüfende Warnung", "Zu prüfende Warnungen"]),
          show: "Warnungen anzeigen",
          hide: "Warnungen ausblenden",
          block_show: "Warnungen dieses Empfängers anzeigen",
        },
        channel: {
          api_opco: "OPCO-API",
          platform: "Plattform-Einreichung",
          email: "E-Mail-Versand",
          unknown: "Unbekannter Kanal",
          region_label: "Fälligkeiten des Kanals {channel}",
        },
        block_total: "Gesamt inkl. Steuer: {amount}",
        empty: "Keine Fälligkeit auf diesem Kanal.",
      },
    },
    name: "Name",
    institution: "Einrichtung",
    component: "Komponente",
    trainingCourse: "Gruppe",
    group: "Gruppe",
    Contact: "Kontakt",
    TrainingContact: "Ausbildungskontakt",
    pedagogicInformations: "Pädagogische Informationen",
    fundingInformations: "Finanzinformationen",
    dates: "Daten",
    from_to: "vom {from} bis {to}",
    hourlyVolume: "Stundenvolumen",
    hourlyRemoteVolume: ({ named }) => `Davon ${named("volume")} Std. Fernunterricht`,
    hourlyCost: "Stundenkosten der Leistung",
    prestationCost: "Leistungsbetrag - Netto der Steuer",
    amount: "Betrag",
    modality: ({ plural }) => plural(["Modalität", "Modalitäten"]),
    in_person: "Präsenz",
    distanciel: "Fernunterricht",
    remoteVolume: "Davon Fernunterricht",
    degreePrepared: "Angestrebter Abschluss",
    level: "Niveau",
    titleRncp: "RNCP-Titel",
    degreeCode: "Abschlusscode",
    calendar: "Kalender",
    program: "Programm",
    apprenticeShipContract: "Ausbildungsvertrag",
    proContract: "Professionalisierungsvertrag",
    rate: "Tarif",
    publicAnnualRate: "Jährliche Kosten öffentliche Arbeitgeber",
    annualRate: "Jährliche Kosten",
    totalRate: "Gesamtkosten",
    hourlyRate: "Stundentarif",
    followUp: "Aktenverfolgung",
    devices: "Geräte",
    createdAt: "erstellt am {date}",
    help: "Hilfe",
    follow: "Verfolgung",
    inProgress: "In Bearbeitung",
    validatedAt: "Validiert am {date} von {validator}",
    steps: "Die Schritte",
    statistics: "Statistiken",
    generalInformations: "Allgemeine Informationen",
    civility: "Anrede",
    firstName: "Vorname",
    birthDate: "Geburtsdatum",
    age: "Alter",
    email: "E-Mail",
    phone: "Telefon",
    address: "Adresse",
    nationality: "Nationalität",
    male: "Herr",
    female: "Frau",
    years: "Jahre",
    apprentice: "Auszubildende(r)",
    tutor: "Betreuer",
    ufa: "UFA",
    cfa: "CFA",
    map: "Ausbildungsmeister",
    function: "Funktion",
    contacts: "Kontakte",
    previousSituation: "Frühere Situation",
    ineCode: "INE-Code",
    preContractSituation: "Situation vor dem Vertrag",
    lastDegreeObtained: "Letzter erworbener Abschluss",
    title: "Bezeichnung",
    lastDegreePrepared: "Letzter vorbereiteter Abschluss",
    lastInstitution: "Letzte Einrichtung",
    uaiCode: "UAI-Code",
    department: "Département",
    socialReason: "Firmenname",
    company: "Unternehmen",
    head_office: "Firmensitz",
    activityCode: "Aktivitätscode (NAF)",
    totalWorkForce: "Gesamtbelegschaft",
    siret: "SIRET",
    employerType: "Arbeitgebertyp",
    employerSubType: "Arbeitgeber-Untertyp",
    idcc: "IDCC",
    opco: "OPCO",
    opcoComparison: {
      title: "Datenvergleich",
      caption: "Vergleich der OPCO- und Studea-Daten",
      baseline: "OPCO-Daten und Studea-Daten",
      empty: "Keine Daten zum Vergleichen",
      label: "Bezeichnung",
      seeDifferences: "Unterschiede anzeigen",
      level: {
        minor: "Geringe Abweichung",
        strict: "Erhebliche Abweichung",
      },
    },
    salaryDetail: {
      empty: "Keine Vergütungsdaten",
    },
    hostCompany: "Aufnahmeunternehmen",
    administratorCompany: "Firmensitz",
    training: "Ausbildung",
    startDate: "Startdatum",
    endDate: "Enddatum",
    hourlyTrainingVolume: "Stundenanzahl",
    apprenticeMaster: "Ausbildungsmeister",
    apprenticeMaster2: "Ausbildungsmeister 2",
    degree: "Abschluss",
    hostCompanyContact: "Kontakt Aufnahmeunternehmen",
    administratorCompanyContact: "Kontakt Firmensitz",
    pricePolicyInfo1:
      "Restkosten nur wenn die Übernahme geringer ist; die Übernahme auf den Tarif begrenzt, auch wenn sie höher ist.",
    pricePolicyInfo2:
      "Restkosten nur wenn die Übernahme geringer als der Tarif ist; wenn höher, wird der Tarif entsprechend der Übernahme angewendet.",
    pricePolicyInfo3: "Der Tarif wird an die Übernahme angepasst.",
    signIn: "Konto erstellen",
    login: "Anmelden",
    loginInfo: "Authentifizieren Sie sich oder erstellen Sie ein Konto, um auf das Anmeldeformular zuzugreifen",
    loginInfo2: "Authentifizieren Sie sich, um auf das Anmeldeformular zuzugreifen",
    needAccount: "Ich habe kein Konto",
    noNeedAccount: "Ich habe bereits ein Konto",
    anApprentice: "Ein/e Alternant/e",
    aCompany: "Ein Unternehmen",
    iAm: "Ich bin",
    createApprenticeAccount: "Alternant/e-Konto erstellen",
    createCompanyAccount: "Unternehmenskonto erstellen",
    accountExist: "Ihre E-Mail wurde erkannt!",
    accountExistSubTitle: "Sie können sich direkt mit Ihren Anmeldedaten in Ihrem Konto anmelden!",
    next: "Weiter",
    prev: "Zurück",
    workInProgress: "Zu validieren",
    valid: "Validiert",
    pending: "In Bearbeitung",
    publicSector: "Öffentlicher Sektor",
    privateSector: "Privatsektor",
    link_copied_success: "Link erfolgreich in die Zwischenablage kopiert!",
    status: {
      upcoming: "Bevorstehend",
      in_progress: "In Bearbeitung",
      finalised: "Abgeschlossen",
      break_up: "Auflösung",
      cancelled: "Abgebrochen",
    },
    insee_company: {
      title: ({ plural }) => plural(["INSEE-Unternehmen", "INSEE-Unternehmen"]),
      siret: "SIRET",
      activity: "Aktivität (NAF/APE)",
      details: "Details (Name, Bezeichnung, Adresse)",
      creation: "Gründung",
      state: "Status",
      social_reason: "Firmenname",
      current: "Aktueller Betrieb",
      head_office: "Firmensitz",
      creation_date: "Gründungsdatum",
      work_force: "Belegschaft",
      status: "Status",
      principal_address: "Hauptadresse",
      secondary_address: "Nebenadresse",
      empty_contact: "Für dieses Unternehmen ist kein Kontakt eingetragen",
      undefined_work_force: "Keine Daten eingetragen",
    },
    training_info: {
      search_by_branch: "Suche nach Tarifvertrag",
      funding_coverage: "Übernahme:",
      decree_cost: "Dekretkosten: ",
      only_different_cost_displayed: "Standardmäßig werden nur Kosten angezeigt, die von den Dekretkosten abweichen",
      info_tab: {
        general_info: "Allgemeine Informationen",
        rncp_sheet: "RNCP-Blatt",
        program: "Programm",
        setttings: "Anmeldungskonfiguration",
        matrix: "UE-Kompetenz-Matrix",
        settings: "Anmeldungskonfiguration",
        npec: "NPEC",
        contact: "Kontakt für Unternehmen",
      },
      general_info: {
        institution_name: "Name der Einrichtung",
        reference: "Referenz",
        rncp_number: "RNCP-Nummer",
        offical_name: "Offizieller Name",
        diplome_type: "Abschlussart",
        mention: "Name / Bezeichnung",
        route: "Weg",
        diplome_code: "Abschlusscode",
        status: "Status",
        logo: "Logo",
        partner_website_url: "URL der Partner-Website",
        link: "Link",
        work_study_duration: "Dauer der Wechselausbildung",
        total_cycle_time: "Gesamtdauer des Zyklus",
        active: "Aktiv",
        archived: "Archiviert",
      },
    },
    alert: {
      title: ({ plural }) => plural(["Warnung", "Warnungen"]),
      level: {
        info: "Information",
        warning: "Warnung",
        error: "Fehler",
      },
      active_unactive: "Aktivieren/Deaktivieren",
      see_more: "Mehr anzeigen",
      empty: "Keine Warnung auf Ebene {level}",
    },
    group_action: {
      see_sheet: "Voranmeldeformular anzeigen",
      see_contract: "Vertrag anzeigen",
      copy_sheet: "Link des Voranmeldeformulars kopieren",
      create: "Voranmeldeformular erstellen",
      cancel: {
        title: "Dieses Voranmeldeformular stornieren",
        confirmation: {
          title: "Sind Sie sicher, dass Sie dieses Formular stornieren möchten?",
          subtitle:
            'Die Anmeldung wird im Dashboard nicht mehr sichtbar sein. Sie können sie wiederherstellen, indem Sie die "stornierten" Formulare auswählen.',
          apprentice_subtitle: "Die Anmeldung wird im Dashboard nicht mehr sichtbar sein.",
        },
        success: "Voranmeldeformular erfolgreich storniert!",
        reset: {
          title: "Dieses Voranmeldeformular reaktivieren",
          confirmation: {
            title: "Sind Sie sicher, dass Sie dieses Formular reaktivieren möchten?",
            subtitle: "Das Formular wird reaktiviert und für andere Benutzer wieder sichtbar sein",
          },
          success: "Voranmeldeformular erfolgreich reaktiviert!",
        },
      },
      see_group_detail: "Gruppendetails anzeigen",
      contact_list: "Kontaktliste",
      delete: {
        confirmation: "Möchten Sie diese Gruppe wirklich löschen?",
        success: "Gruppe erfolgreich gelöscht!",
      },
      download: {
        commitments: "Engagementzertifikat herunterladen",
      },
    },
    dashboard: {
      go_to: "Zum Dashboard dieser Ausbildung wechseln",
      go_to_institution: "Zum Dashboard der Einrichtung wechseln",
    },
    creation: {
      alert: {
        title: "Für diese Ausbildung existiert bereits eine Anmeldung",
        multipleTitle: "Sie haben bereits Anmeldungen für diese Ausbildung",
      },
      info: "Um ein neues Anmeldeformular zu erstellen, geben Sie bitte zuerst die Kandidatendaten ein",
      success: ({ named }) => `Voranmeldeformular von ${named("firstName")} ${named("lastName")} erfolgreich erstellt!`,
    },
    user_not_connected: "Sie müssen sich anmelden, um auf diesen Bereich zuzugreifen",
    quote: {
      contract: "Vertrag",
      financial: "Finanzierung",
      amount: "Betragstabelle",
      edit_cost: "Kosten bearbeiten",
      subtitle: "Finanzielle Zusammenfassung des Ausbildungsvertrags",
      initial_cost: "Anfangskosten",
      final_cost: "Endkosten",
      modal_alert:
        "Diese Änderungen wirken sich auf den dem Unternehmen berechneten Betrag aus. Stellen Sie sicher, dass die Beträge Ihrer Vereinbarung entsprechen.",
      updated_cost: ({ plural, named }) => plural(["1 Betrag geändert", `${named("number")} Beträge geändert`]),
      no_updated_cost: "Kein Betrag geändert",
      edit: {
        date: {
          title: "Ausbildungsdaten bearbeiten (für diese Akte)",
          success: "Änderung der Ausbildungsdaten erfolgreich durchgeführt!",
        },
        cost: {
          title: "Beträge bearbeiten",
          success: "Beträge erfolgreich geändert!",
          reset_cost: "Beträge zurücksetzen",
          confirmation: "Sind Sie sicher, dass Sie diese Beträge bestätigen möchten?",
          reset_confirmation: "Sind Sie sicher, dass Sie diese Beträge zurücksetzen möchten?",
          reset_success: "Beträge erfolgreich zurückgesetzt!",
          previous_amount: ({ named }) => `zuvor ${named("amount")}`,
          reference_legend: ({ named }) => `Beträge aus der am ${named("date")} versendeten Vereinbarung/dem Angebot`,
        },
      },
      table: {
        columns: {
          trainingCourseCost: "Ausbildungskosten",
          opcoo: "Übernahme",
          mandatory_participation: "Pflichtbeitrag",
          mandatory_participation_tooltip:
            "Anteil der Finanzierung, der durch die Maßnahme oder den Finanzierer vorgegeben wird.\n" +
            "Er wird gegebenenfalls zum verbleibenden Eigenanteil hinzugerechnet.\n" +
            "Gemäß Artikel L6332-14 des französischen Arbeitsgesetzbuchs kann vom Arbeitgeber ein Beitrag verlangt werden.",
          remaining_cost: "Restkosten",
          remaining_cost_tooltip:
            "Betrag, der nicht vom Finanzierer übernommen wird.\n" +
            "Er ist vom Pflichtbeitrag zu unterscheiden und hängt von den durch den OPCO validierten Übernahmebedingungen ab.",
        },
      },
      duration: {
        title: "Dauer",
      },
      billingStartDate: {
        title: "Startdatum",
      },
      billingEndDate: {
        title: "Enddatum",
      },
      caption: {
        title: "* Beträge ohne MwSt. – MwSt.-Befreiung",
        subtitle: "(Art. 261, 4-4° des CGI, Lehrtätigkeit).",
      },
      title: "Kostenvoranschlag",
      verify: "Kostenvoranschlag prüfen",
      cost_historic: "Versionsverlauf — Finanztabelle",
      convention: {
        title: "Vereinbarung",
      },
    },
    contact: {
      title: "Ein Kontakt",
      success: "Kontakt erfolgreich hinzugefügt!",
      info: "Geben Sie die Kontaktperson im Unternehmen an. Sie können bei Abwesenheit mehrere Kontakte hinzufügen. Der Kontakt erhält die E-Mail bei der Validierung des Schritts.",
      edit_succes: "Kontakt erfolgreich geändert!",
      edit: {
        success: "Kontakt erfolgreich geändert!",
        alert: "Diese Änderungen gelten für das Benutzerkonto auf der gesamten Plattform.",
      },
      delete: {
        confirmation: "Sind Sie sicher, dass Sie diesen Kontakt löschen möchten?",
        success: "Kontakt erfolgreich gelöscht!",
      },
      director: "Geschäftsführer/in / Unterzeichner/in",
      temporary: "Temporärer Kontakt",
      interlocutor: "Ansprechpartner/in administrative Verwaltung",
      billing: "Rechnungskontakt",
      attendance: "Anwesenheitskontakt",
      gestionnary: "Verwalter/in",
      different_name: "Dieser Name erscheint auf der Vereinbarung, erstellt aber kein Benutzerkonto.",
      mail_status: {
        waiting: "Wartet auf Aktivierung",
        send: "E-Mail versendet",
        active: "Aktiv",
      },
      account: {
        already_exist: {
          title: "Dieses Konto existiert bereits",
          subtitle:
            "Die eingegebene E-Mail-Adresse wird bereits von einem Konto verwendet (1 E-Mail = 1 Benutzer). Der Kontoinhaber kann seine Kontaktdaten in seinem persönlichen Bereich ändern",
        },
      },
      registration: {
        title: "Einschreibungskontakt",
        empty: "Kein Einschreibungskontakt angegeben",
      },
      company: {
        title: "Unternehmenskontakt (HR-Ansprechpartner/in)",
        empty: "Kein Unternehmenskontakt angegeben",
      },
    },
    reminder: {
      title: "Unternehmenslink-Benachrichtigung erneut senden",
      confirmation: {
        title: "Möchten Sie die Unternehmenslink-Benachrichtigung wirklich erneut senden?",
      },
      send: "Senden",
      success: "Benachrichtigung erfolgreich gesendet!",
    },
    comment: {
      title: "Kommentare",
      new: "Neu",
      unread: ({ plural }) => plural(["Ungelesene Nachricht", "Ungelesene Nachrichten"]),
      actions: ({ plural }) => plural(["Erforderliche Maßnahme", "Erforderliche Maßnahmen"]),
      add: "Kommentar hinzufügen",
      empty: "Kein Kommentar eingetragen",
      action_required: {
        done: "Ich habe diese Aktion durchgeführt",
        doneBy: "Aktion durchgeführt von",
      },
      delete: {
        success: "Kommentar erfolgreich gelöscht!",
        confirmation: "Sind Sie sicher, dass Sie diesen Kommentar löschen möchten?",
      },
    },
    contractType: {
      apprentice: "Auszubildende",
      pro: "Professionalisierungsvertrag",
    },
    document: {
      cerfa: {
        title: "CERFA",
        notice: "Hinweise ansehen",
      },
      convention: {
        title: "Vereinbarung",
      },
      update: {
        success: ({ named }) => `Ihr ${named("document")} wurde erfolgreich gespeichert!`,
      },
      upload_at: `Hochgeladen am {date}`,
      version: "Version",
      status: {
        correction_requested: "Korrektur angefordert",
        verified: "Verifiziert",
        sent: "Gesendet",
        deposited: "Hinterlegt",
        to_send: "Zu senden",
        to_be_modified: "Änderung erforderlich",
        validated: "Validiert",
        to_verify: "Zu prüfen",
      },
      actual_version: "Aktuelle Version",
      delete: {
        confirmation: "Möchten Sie diese Version wirklich löschen?",
        success: "Version erfolgreich gelöscht!",
      },
      validate: {
        confirmation: "Möchten Sie dieses Dokument wirklich validieren?",
        success: "Dokument erfolgreich validiert!",
      },
      change: {
        title: "Korrekturanfrage",
        success: "Ergänzungsanfrage erfolgreich gesendet!",
        cancel: {
          confirmation: "Sind Sie sicher, dass Sie diese Ergänzungsanfrage stornieren möchten?",
          success: "Ergänzungsanfrage erfolgreich storniert!",
        },
      },
      verification: {
        title: "Dokumente prüfen",
        modal: "Überprüfung",
        ask_modification: "Änderungsanfrage",
        cancel_ask_modification: "Ergänzungsanfrage stornieren",
        sign: "Dokument visieren",
      },
      empty: "Keine Datei gefunden",
      error: "Beim Anzeigen des PDFs ist ein Fehler aufgetreten",
      uploaded: "Hochgeladene Datei",
      generated: "Generierte Datei",
      validation: {
        not_verify: "Das CERFA und die Vereinbarung müssen überprüft werden, um diesen Schritt zu validieren",
      },
    },
    step: {
      in_progress: "Schritt in Bearbeitung",
      validation: {
        success: "Schritt erfolgreich validiert!",
      },
    },
    tab: {
      error: "Einige Felder in diesem Tab enthalten Fehler, bitte überprüfen Sie diese",
    },
    stamp: {
      action: "Stempelmodus",
      stamped: { confirmed: "Dokument erfolgreich gestempelt!" },
      cancel: "Stempelmodus verlassen",
      tooltip: "PDF stempeln,\nder Stempel erscheint,\nin der Mitte des Cursors\n(Größe: 90x40 mm)",
      remove: {
        title: "Stempel entfernen",
        confirmation: "Sind Sie sicher, dass Sie den Stempel entfernen möchten?",
        success: "Stempel erfolgreich entfernt",
      },
    },
    save: {
      success: "Ihr Anmeldeformular wurde erfolgreich gespeichert!",
    },
    request_changes: {
      title: "Ergänzungsanfrage",
      confirmation: "Sind Sie sicher, dass Sie diese Ergänzungsanfrage senden möchten?",
      success: "Ergänzungsanfrage erfolgreich gesendet!",
      recipients: "Die Ergänzungsanfrage wird an folgende Empfänger gesendet:",
      requestAt: "Ergänzungsanfrage vom {date} durch {validator} durchgeführt",
      cancel: {
        confirmation: "Sind Sie sicher, dass Sie diese Ergänzungsanfrage stornieren möchten?",
        success: "Ergänzungsanfrage erfolgreich storniert!",
      },
      new_submission: {
        confirmation: "Sind Sie sicher, dass Sie eine neue Einreichung des Formulars vornehmen möchten?",
        success: "Formular erfolgreich erneut eingereicht!",
      },
    },
    download_training_sheet: "Ausbildungsinformationsblatt herunterladen",
    ypareo: {
      title: "Ypareo",
      sync_button: "Mit Ypareo synchronisieren",
      sync_success: "Akte mit Ypareo synchronisiert",
      sync_error: "Ypareo-Synchronisierung fehlgeschlagen",
      running: "Synchronisierung läuft…",
      error_indicator: "Synchronisierungsfehler",
      synced_at: "Synchronisiert am {date} (Ypareo-ID {id})",
      resend_button: "Erneut senden",
      log_title: "Ypareo-Synchronisierungsprotokoll",
      log_date: "Datum",
      log_created: "Erstellt",
      log_updated: "Aktualisiert",
      log_excluded: "Übersprungen",
      log_errors: "Fehler",
      log_empty: "Kein Protokoll für diese Akte verfügbar.",
      error_tooltip: "Ypareo-Synchronisierungsfehler: {ypareo_sync_error}",
    },
    create: {
      confirmation: "Möchten Sie wirklich ein neues Voranmeldeformular erstellen?",
      alert: {
        confirm: "Zu Ihrer Akte zugreifen",
        cancel: "Eine neue Akte erstellen",
        multipleConfirm: "Zu Ihren Akten zugreifen",
      },
    },
    empty_registation_list: "Kein Registrierungsformular verfügbar",
    company_dashboard: {
      following_contract: {
        title: "Vertragsliste",
      },
    },
    contract_status: {
      init: "Initialisiert",
      to_send_to_training_center: "Zum Versand bereit",
      sent_to_training_center: "Versendet",
      validated_training_center: "Validiert",
      signed: "Unterzeichnet",
      error: "Fehler",
      archived: "Archiviert",
    },
    opco_submission: {
      title: "An OPCO übermitteln",
      convention: "Vereinbarung",
      folder: "Akte",
      confirmation: {
        title: "Übermittlung an OPCO bestätigen",
        subtitle: {
          title: "Durch die Übermittlung der Akte an den OPCO bestätigt das CFA:",
          li_1: "Die Richtigkeit der in diesem Antrag genannten Informationen",
          li_2: "Dass die im Formular eingetragenen Informationen mit den Informationen des mit dem/der Auszubildenden abgeschlossenen Vertrags übereinstimmen",
          li_3: "Dass das CERFA vom zuständigen Ausbildungsträger geprüft wurde",
          li_4: "Dass das CERFA von den Parteien unterzeichnet wurde (Arbeitgeber, Auszubildende(r) und ggf. deren gesetzlicher Vertreter)",
          li_5: "Sich verpflichtet, die Belege den Kontrollbehörden (OPCO, Verwaltung) zur Verfügung zu halten",
        },
        confirm: "Übermittlung bestätigen",
      },
      json: {
        title: "An OPCO gesendetes JSON",
        see: "Gesendetes JSON anzeigen",
        received: {
          title: "Von OPCO empfangenes JSON",
          see: "JSON anzeigen",
        },
      },
      success: {
        title: "Akte erfolgreich übermittelt",
      },
      error: {
        title: "Übermittlung fehlgeschlagen",
      },
      response: {
        title: "OPCO-Rückmeldung",
        message: "Rückmeldungsnachricht",
      },
      status: {
        success: "Erfolgreich",
        in_progress: "In Bearbeitung...",
        failed: "Fehlgeschlagen",
        waiting: "Warten auf Versand",
      },
      message: {
        processing: "Wird gesendet",
      },
      manual: {
        alert:
          "Der Arbeitgeber ist für den Abschluss und die Übermittlung des Ausbildungsvertrags (Ausbildung oder Weiterbildung) an seinen Kompetenzträger (OPCO) bzw. bei öffentlichen Arbeitgebern an die DREETS verantwortlich, und zwar unmittelbar nach der Unterzeichnung, spätestens jedoch innerhalb von 5 Werktagen nach Vertragsbeginn. Diese Übermittlung ist entscheidend, um finanzielle Hilfen auszulösen und den Sozialversicherungsschutz sicherzustellen.",
        success: "OPCO-Übermittlung erfolgreich durchgeführt!",
      },
    },
    opco_folder: {
      send: {
        done: "OPCO-Übermittlung abgeschlossen",
      },
      last_sync: "Letzte Synchronisierung: {date}",
    },
    first_connexion: "Erste Anmeldung",
    actor: {
      cfa: "CFA",
      ufa: "UFA",
      company: "Unternehmen",
    },
    legal_responsible: {
      required: "Sie müssen mindestens einen gesetzlichen Vertreter hinzufügen (Maximal 2)",
      add: "Einen gesetzlichen Vertreter hinzufügen",
      add_second: "Einen zweiten gesetzlichen Vertreter hinzufügen",
      edit: "Einen gesetzlichen Vertreter bearbeiten",
      success_add: "Gesetzlicher Vertreter erfolgreich hinzugefügt.",
      success_edit: "Gesetzlicher Vertreter erfolgreich geändert.",
      delete: {
        success: "Gesetzlicher Vertreter erfolgreich gelöscht.",
        confirmation: "Sind Sie sicher, dass Sie diesen gesetzlichen Vertreter löschen möchten?",
      },
    },
    correction_requested: {
      title: "Änderungsanfragen",
      historic: "Verlauf der Änderungsanfragen",
      creation: "Korrektur angefordert von {creator} am {date}",
    },
    params: {
      give_mandat: "Konfiguration des Verwaltungsmandats",
    },
    updated_cost: ({ plural, named }) => plural(["1 Betrag geändert", `${named("number")} Beträge geändert`]),
    no_updated_cost: "Kein Betrag geändert",
    contract: {
      title: "Vertrag",
      see_more: "Mehr anzeigen",
      see_less: "Weniger anzeigen",
      empty: "Kein Vertrag verfügbar",
      see: "Vertrag öffnen",
      error: "Einige Angaben sind nicht korrekt, bitte korrigieren Sie sie im Anmeldeformular",
      synchronize: {
        confirm: "Sind Sie sicher, dass Sie diesen OPCO synchronisieren möchten?",
        success: "Synchronisierung erfolgreich abgeschlossen!",
      },
      opco: {
        edit: {
          success: "OPCO-Informationen erfolgreich geändert!",
        },
      },
      billing: {
        title: "Finanzübersicht des Vertrags",
      },
    },
    amendment: "Nachtrag",
    mission: "Aufgaben",
    salary: "Vergütung",
    financing_amount: "Finanzübersicht — Angebot",
    invoice_tab: {
      title: "Finanzierung/Rechnungsstellung",
    },
    due_date: {
      valid: "OPCO-Fälligkeiten akzeptieren",
      edit: "Aufteilung bearbeiten",
    },
    schedule: {
      title: "Zahlungsplan",
      company: "Unternehmen",
      mode: {
        title: "Modus",
        description:
          "Voraussichtlich = ursprünglicher Zahlungsplan vor Erhalt der APEC, OPCO = über die Convergence-API erhalten, Manuell = vom CFA geändert",
        unavailable: "Dieser Modus ist für diesen Vertrag nicht verfügbar",
      },
      forecast: "Voraussichtlich",
      manual: "Manuell",
      empty: "Noch kein Zahlungsplan vorhanden",
      error: "Beim Laden des Zahlungsplans ist ein Fehler aufgetreten",
      column_installment: "Fälligkeit",
      column_type: "Typ",
      column_start_date: "Beginn",
      column_end_date: "Ende",
      column_amount: "Betrag",
      type: {
        initial: "Initial",
        intermediate: "Zwischenzahlung",
        balance: "Saldo",
      },
      manual_edit: {
        edit_button: "Manuelle Aufteilung bearbeiten",
        title: "Manuelle Aufteilung der Fälligkeiten",
        locked: "Gesperrte Fälligkeit",
        locked_amount: "Betrag der Fälligkeit {installment} (gesperrt): {amount}",
        locked_start_date: "Startdatum der Fälligkeit {installment} (gesperrt): {date}",
        locked_end_date: "Enddatum der Fälligkeit {installment} (gesperrt): {date}",
        amount_label: "Betrag der Fälligkeit {installment}",
        start_date_label: "Startdatum der Fälligkeit {installment}",
        end_date_label: "Enddatum der Fälligkeit {installment}",
        add_line: "Fälligkeit hinzufügen",
        delete_line: "Fälligkeit {installment} löschen",
        delete_confirmation:
          "Diese Fälligkeit löschen? Ihr Betrag wird auf die nächstgelegene nicht gesperrte Fälligkeit übertragen.",
        reset: "Zurücksetzen",
        reset_confirmation:
          "Manuellen Zahlungsplan zurücksetzen? Alle nicht gesperrten Fälligkeiten werden durch die automatische Berechnung ersetzt.",
        save: "Speichern",
        balance_target: "Verpflichteter Nettobetrag",
        balance_current: "Verteilter Gesamtbetrag",
        balance_gap: "Abweichung",
        balance_ok: "Der Zahlungsplan ist ausgeglichen.",
        balance_error: "Die Summe der Beträge muss dem verpflichteten Nettobetrag entsprechen, um speichern zu können.",
        saved: "Manuelle Aufteilung gespeichert",
        error: "Beim Aktualisieren der manuellen Aufteilung ist ein Fehler aufgetreten",
      },
    },
    export: {
      workflow: "Export der Anmeldungen (Ablauf)",
      contract_data: "Verträge",
      missions: "Missionen exportieren",
      financial: "Finanzexport",
    },
  },
};
